import request from '@/service';

// get 请求
export function getProductList (params) {
  return request({
    url: '/ft/case/list?sign=1&appId=1',
    method: 'get',
    params
  })
}
